export default "__VITE_ASSET__k7K1vB7z__"